import React from 'react';
import { withRouter, Redirect } from 'react-router'; 

import Button from '../UI/Button/Button';
import HeadingH3 from '../UI/Headings/HeadingH3/HeadingH3';
import FlightNote from '../Flight/Tuple/TupleInner/FlightInfo/FlightNote/FlightNote';
import sessionTimeoutImage from './img/session-time-out.png';

const SessionTimeout = (props) => (
    <div style={{transform: props.diff !== 0 && !props.hideFareAlert ? 'translateX(0)' : 'translateX(100%)'}} className={`u-width100Percent u-height100Percent u-fixed u-transition--transform200Spring phone-pt-0 u-backgroundColorWhite u-zIndex10`}>
        <div className={`pt-12 pl-6 pr-6 pb-4 u-backgroundColorWhite u-height100Percent phone-p-4`}>
            <div className={`mb-10`}>
                <HeadingH3 size={16} weight="Medium" color="Dark">Session Expired</HeadingH3>
            </div>
            <div className="mb-10">
                <img src={sessionTimeoutImage} alt='Timeout'/>
            </div>
            <div className="mb-4">
                <p className={`u-textColorNormal`}>Still interested in flying from {props.origin} to {props.destination}?</p>
            </div>
            <div className="mb-10">
                <FlightNote>Please recheck Fare &amp; Availability of your selected flight(s) as air fares are dynamic and subject to change.</FlightNote>
            </div>
            <div>
                <div className={`mb-4`}>
                    <Button onClick={() => props.history.push(props.url)} theme='OutlinePrimary' width='Block' type='Submit'>Back To Search Results</Button>
                </div>
                <div>
                    <Button onClick={() => window.location.reload()} theme='Primary' width='Block' type='Submit'>Check Latest Fares</Button>
                </div>
            </div>
        </div>
    </div>
);

export default withRouter(SessionTimeout);


// WEBPACK FOOTER //
// ./src/components/SessionTimeout/SessionTimeout.js